<template>
  <editor-item-content-image
    v-if="src"
    :src="src"
    @loaded="$emit('loaded', { element: value, content: $event })"
    @loading="$emit('loading', { element: value, content: $event })"
  />
</template>
<script>
import EditorItemContentImage from '../fragments/EditorItemContentImage.vue';

export default {
  name: 'EditorItemUpload',
  components: { EditorItemContentImage },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  asyncComputed: {
    async src() {
      return this.$compositionRenderer.uploadResolver(this.value);
    }
  }
};
</script>
